/**
 * Greeting Card Selector — Gift Pack product pages.
 *
 * When a greeting card radio tile is selected and the customer clicks
 * Add to Cart, this script:
 *  1. POSTs the card as a separate cart line item with bundle-link properties
 *  2. Then allows the main product form to submit normally
 *
 * If no card is selected, the main form submits immediately without changes.
 * If the card add fails (e.g. sold out), an inline error is shown but the
 * main product still adds to cart successfully.
 */
(function ($) {
  'use strict';

  var GreetingCardSelector = {

    init: function () {
      var container = document.querySelector('[data-greeting-card-selector]');
      if (!container) return;

      this.container = container;
      this.checkbox = container.querySelector('#greeting-card-toggle');
      this.gridWrap = container.querySelector('.greeting-card-selector__grid-wrap');
      this.toggleIcon = container.querySelector('.greeting-card-selector__toggle-icon');
      this.errorEl = container.querySelector('[data-greeting-card-error]');

      if (!this.checkbox) return;

      this.bindToggle();
      this.bindAddToCart();
    },

    bindToggle: function () {
      var self = this;
      this.checkbox.addEventListener('change', function () {
        if (self.checkbox.checked) {
          self.gridWrap.classList.add('greeting-card-selector__grid-wrap--visible');
          if (self.toggleIcon) self.toggleIcon.classList.add('greeting-card-selector__toggle-icon--open');
        } else {
          self.gridWrap.classList.remove('greeting-card-selector__grid-wrap--visible');
          if (self.toggleIcon) self.toggleIcon.classList.remove('greeting-card-selector__toggle-icon--open');
          // Reset to "none" selection
          var noneRadio = self.container.querySelector('#greeting-card-none');
          if (noneRadio) noneRadio.checked = true;
          self.hideError();
        }
      });
    },

    getSelectedCard: function () {
      var radios = this.container.querySelectorAll('.greeting-card-selector__radio');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          return {
            variantId: radios[i].value,
            title: radios[i].getAttribute('data-card-title') || '',
            price: radios[i].getAttribute('data-card-price') || ''
          };
        }
      }
      return null;
    },

    showError: function (msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.style.display = 'block';
    },

    hideError: function () {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.style.display = 'none';
    },

    bindAddToCart: function () {
      var self = this;

      // Find the product form — same strategy as gift-message.js
      var form = this.container.closest('form[action*="/cart/add"]');
      if (!form) {
        var wrapper = this.container.closest('[data-product-form]');
        if (wrapper) form = wrapper.querySelector('form');
      }
      if (!form) return;
      this.form = form;

      // Intercept the add-to-cart button in capture phase (same approach as ptwAfterWrapinLoadHook)
      var addBtn = form.querySelector('.button--add-to-cart');
      if (!addBtn) return;

      addBtn.addEventListener('click', function (e) {
        // Only intercept if our toggle is checked and a card is selected
        if (!self.checkbox || !self.checkbox.checked) return true;

        var card = self.getSelectedCard();
        if (!card || !card.variantId) return true; // no card chosen — pass through

        // Get the gift pack's selected variant id
        var packVariantId = form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null;
        if (!packVariantId || packVariantId === 'not-selected') return true;

        // Get the gift pack product title for the bundle reference
        var packTitle = (form.querySelector('[data-product-title]') || {}).textContent
          || document.querySelector('.product-title, h1.title, .product__title')
          ? (document.querySelector('.product-title, h1.title, .product__title') || {}).textContent || ''
          : '';
        packTitle = packTitle.trim();

        e.preventDefault();
        e.stopImmediatePropagation();

        self.hideError();
        self.setLoading(addBtn, true);

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: String(card.variantId),
            quantity: '1',
            'properties[_part_of_bundle]': packTitle,
            'properties[_bundle_variant_id]': String(packVariantId)
          },
          dataType: 'json',
          cache: false
        }).always(function () {
          // Whether card add succeeded or failed, submit the main product form
          self.setLoading(addBtn, false);
          // Let the theme handle the actual product add via normal form submit
          self.submitMainForm(form, addBtn);
        }).fail(function (xhr) {
          var msg = 'Greeting card could not be added. Your gift pack has been added instead.';
          try {
            var resp = JSON.parse(xhr.responseText);
            if (resp && resp.description) msg = resp.description;
          } catch (err) { /* ignore */ }
          self.showError(msg);
        });

        return false;
      }, true); // capture phase — runs before theme handlers
    },

    submitMainForm: function (form, addBtn) {
      // Re-trigger a click on the button without our interceptor, or submit form directly.
      // We remove our listener flag and let the theme's own AJAX handler run.
      // Simplest safe approach: fire native click after a tick so our capture listener
      // won't re-intercept (the card was already added so we pass through).
      var self = this;
      // Temporarily uncheck the toggle so our interceptor passes through
      var prevChecked = self.checkbox.checked;
      self.checkbox.checked = false;
      setTimeout(function () {
        try {
          addBtn.click();
        } catch (e) {
          try { form.submit(); } catch (e2) { /* ignore */ }
        }
        // Restore checkbox visual state (don't re-enable since the page may refresh)
        self.checkbox.checked = prevChecked;
      }, 0);
    },

    setLoading: function (btn, state) {
      if (!btn) return;
      if (state) {
        btn.classList.add('is-loading');
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
      }
    }
  };

  $(document).ready(function () {
    GreetingCardSelector.init();
  });

})(jQuery);
